// extracted by mini-css-extract-plugin
module.exports = {"widget":"TendersWidget_widget__36zgn"};